import { forwardRef, type Ref, type SVGProps } from "react";
const IconMicrophoneOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 4.19a2.93 2.93 0 0 1 2.84 3v8.62a2.93 2.93 0 0 1-2.83 3 2.92 2.92 0 0 1-2.82-3V7.19a2.92 2.92 0 0 1 2.81-3M16 2a5.07 5.07 0 0 0-5 5.16v8.65A5.07 5.07 0 0 0 16 21a5.09 5.09 0 0 0 5-5.16V7.19A5.09 5.09 0 0 0 16 2" />
    <path d="M26 16.38a1 1 0 1 0-1.94 0A7.84 7.84 0 0 1 16 24a7.84 7.84 0 0 1-8-7.62 1 1 0 0 0-1.94 0 9.74 9.74 0 0 0 9 9.52.2.2 0 0 0-.06.1v2h-2a1 1 0 1 0 0 2h6a1 1 0 0 0 0-2h-2v-2a.2.2 0 0 0 0-.07 9.74 9.74 0 0 0 9-9.55" />
  </svg>
);
const ForwardRef = forwardRef(IconMicrophoneOutlineSVG);
ForwardRef.displayName = "IconMicrophoneOutline";
export { ForwardRef as IconMicrophoneOutline };
